import axios from 'axios';
import jwt_decode from 'jwt-decode';
import { createContext, useReducer, useState } from 'react';
import {
  CONSULTORIO_CONNECTION_BLOCKING_REASON,
  fallbackOsdeContratoPayload
} from '../utils/Constants/consultorioConnectionBlocking';
import appReducer from './AppReducer';
//import { getMock } from '../utils/mockData/getMock';

/*
getToken: Realiza una solicitud del token que llega una vez que el prestador se loguea. El mismo sera utilizado para: 
  - Mostrar el nombre del prestador en la navBar.
  - Con el IC que llega en el token, se envia al back y este se utiliza para obtener el Contrato Iteligente en CRM que luego se utiliza para solicitar la informacion del prestador en CI.
getOSDE: Realiza una solicitud de los prestadores que se encuentran en CI.
getExterno: Realiza una solicitud de los prestadores del sistema externo elegido.
getAgendas: Realiza una solicitud de los sistemas externos que estan disponibles para interoperar.
getSolicitudes: Realiza una solicitud de las solicitudes que el prestador ha realizado previamente.
postSolicitud: Envia la solicitud a la tabla solicitudes que el prestador ha cargado.
? deleteSolicitud:
? anularSolicitud
*/

const initialState = {
  proveedores: [],
  prestadorSesion: null,
  prestadoresOsde: undefined,
  prestadorExterno: undefined,
  solicitudesPrestador: [],
  consultorios: [],
  solicitudDetail: null,
  consultorioDetail: null,
  errorAuthPrestador: null,
  contratos: [],
  consultoriosContrato: [],
  solicitudesContrato: [],
  motivosRechazo: null,
  icWithContrato: null
};

export const AgendaContext = createContext(initialState);

const AgendaContextProvider = ({ children }) => {
  const { REACT_APP_PRESTADOR_API_URL } = process.env;

  const [state, dispatch] = useReducer(appReducer, initialState);
  const [prestadorLogueado, setPrestadorLogueado] = useState({});

  const [isLoading, setIsLoading] = useState(true);

  const [proveedorSeleccionado, setProveedorSeleccionado] = useState(null);

  const [solicitudProps, setSolicitudProps] = useState({ datosContacto: [] });

  const [cuitNumber, setCuitNumber] = useState('');

  const [datosContactoPrestadorLogeado, setDatosContactoPrestadorLogeado] = useState([]);

  // Seleccion de contrato
  const [filialSeleccionada, setFilialSeleccionada] = useState(null);
  const [contratoSeleccionado, setContratoSeleccionado] = useState(null);

  const [useBlockerOK, setUseBlockerOK] = useState(false);

  const TOKEN = `${process.env.REACT_APP_PROFILE}_PRESTADOR_TKN`;
  const getToken = async () => {
    const res = await axios.get('/prestador/get-token');
    // const res = getMock('token');
    // Store the token in local storage
    localStorage.setItem(TOKEN, 'Bearer ' + res.data.token);
    setPrestadorLogueado(jwt_decode(res.data.idToken));
  };

  const initialize = async () => {
    axios.defaults.headers.common['Authorization'] = localStorage.getItem(TOKEN);
    try {
      const resultado = await axios.get(`${REACT_APP_PRESTADOR_API_URL}/proveedores`);
      //const resultado = getMock('proveedores');
      dispatch({ type: 'GET_PROVEEDORES', payload: resultado.data || [] });
    } catch (error) {
      throw new Error(error);
    }
    try {
      axios.defaults.headers.common['Authorization'] = localStorage.getItem(TOKEN);
      const resultadoOsde = await axios.get(`${REACT_APP_PRESTADOR_API_URL}/consultorios/osde`);
      // const resultadoOsde = getMock('osde');
      dispatch({ type: 'GET_OSDE', payload: resultadoOsde.data || [] });
    } catch (error) {
      throw new Error(error);
    }
    await getContratosWithIC();
  };
  const postRegistrarAcceso = async () => {
    axios.defaults.headers.common['Authorization'] = localStorage.getItem(TOKEN);

    try {
      const resultado = await axios.post(`${REACT_APP_PRESTADOR_API_URL}/usuario/registrarAcceso`);

      dispatch({ type: 'POST_REGISTRAR_ACCESO', payload: resultado.data });
    } catch (error) {
      throw new Error(error);
    }
  };
  const getPrestadorSesion = async () => {
    axios.defaults.headers.common['Authorization'] = localStorage.getItem(TOKEN);
    const resultado = await axios.get(`${REACT_APP_PRESTADOR_API_URL}/session`);
    // const resultado = getMock('session');
    dispatch({ type: 'GET_PRESTADOR_SESSION', payload: resultado.data });
  };

  const getAllConsultorios = async () => {
    axios.defaults.headers.common['Authorization'] = localStorage.getItem(TOKEN);
    const resultado = await axios.get(`${REACT_APP_PRESTADOR_API_URL}/consultorios`);
    // const resultado = getMock('consultorios');
    dispatch({ type: 'GET_CONSULTORIOS', payload: resultado.data });
  };

  const getVerifUsuarioAuth = async () => {
    await getToken();
    axios.defaults.headers.common['Authorization'] = localStorage.getItem(TOKEN);
    try {
      const resultado = await axios.get(`${REACT_APP_PRESTADOR_API_URL}/autenticacion`);
      // const resultado = true;
      return resultado;
    } catch (error) {
      dispatch({ type: 'ERROR_AUTH', payload: error.response.data });
      throw new Error(error.response.data);
    }
  };

  const getDatosContactoPrestador = async (idEfector) => {
    axios.defaults.headers.common['Authorization'] = localStorage.getItem(TOKEN);
    if (contratoSeleccionado) {
      const resultado = await axios.get(
        `${REACT_APP_PRESTADOR_API_URL}/datosPrestadoresContacto/` + idEfector
      );
      // const resultado = getMock('datosPrestadoresContacto');
      setDatosContactoPrestadorLogeado(resultado.data);
    }
  };

  const logout = async () => {
    const { data } = await axios.get('/prestador/revoke');
    localStorage.clear();
    window.location.replace(data);
  };

  const getExterno = async (cuit, seleccion) => {
    axios.defaults.headers.common['Authorization'] = localStorage.getItem(TOKEN);
    try {
      const resultado = await axios.get(
        `${REACT_APP_PRESTADOR_API_URL}/consultorios/externo?identifier=${cuit}&provider=${seleccion}`
      );
      // const resultado = getMock('externo');
      dispatch({ type: 'GET_EXTERNO', payload: resultado.data });
      return resultado;
    } catch (error) {
      throw new Error(error);
    }
  };

  const getSolicitudes = async () => {
    setIsLoading(true);
    axios.defaults.headers.common['Authorization'] = localStorage.getItem(TOKEN);
    const resultado = await axios.get(`${REACT_APP_PRESTADOR_API_URL}/solicitudes/`);
    // const resultado = getMock('solicitudes');

    if (resultado.status == 200 && Array.isArray(resultado.data)) {
      dispatch({ type: 'GET_SOLICITUDES_PREVIAS', payload: resultado.data });
    }
    setIsLoading(false);
  };

  const getInfoSolicitud = async (id) => {
    try {
      const resultado = await axios.get(`${REACT_APP_PRESTADOR_API_URL}/solicitudes/${id}`);
      dispatch({ type: 'GET_SOLICITUD_DETAIL', payload: resultado.data });
    } catch (error) {
      console.error('Error fetching solicitud detail', {
        status: error.response?.status
      });
    }
  }

  const getMotivosRechazo = async () => {
    axios.defaults.headers.common['Authorization'] = localStorage.getItem(TOKEN);
    const resultado = await axios.get(`${REACT_APP_PRESTADOR_API_URL}/solicitudes/motivosRechazo`);
    dispatch({ type: 'GET_MOTIVOS_RECHAZO', payload: resultado.data });
  };

  const postSolicitud = async () => {
    axios.defaults.headers.common['Authorization'] = localStorage.getItem(TOKEN);
    const resultado = await axios.post(`${REACT_APP_PRESTADOR_API_URL}/solicitudes`, {
      ...solicitudProps,
      identificador: cuitNumber
    });

    dispatch({ type: 'STORE_SOLICITUD', payload: resultado.data });
    return resultado;
  };

  const postSolicitudModificar = async (solicitudesDto) => {
    const resultado = await axios.post(`${REACT_APP_PRESTADOR_API_URL}/solicitudes`, {
      ...solicitudesDto,
      identificador: cuitNumber
    });
    dispatch({ type: 'STORE_SOLICITUD', payload: resultado.data });
    return resultado;
  };

  const postInformarProveedor = async (proveedor) => {
    const contratoGuardado = localStorage.getItem('contratoSeleccionado');
    const resultado = await axios.post(`${REACT_APP_PRESTADOR_API_URL}/proveedorNoHomologado`, {
      proveedor: proveedor,
      idEfector: contratoGuardado
    });
    return resultado;
  };

  const anularSolicitud = async (id, payload) => {
    try {
      axios.defaults.headers.common['Authorization'] = localStorage.getItem(TOKEN);

      // Esperar la respuesta del servidor
      const response = await axios.patch(
        `${REACT_APP_PRESTADOR_API_URL}/solicitudes/${id}?estado=${payload}`
      );

      // Verificar si fue exitosa (status 2xx)
      if (response.status >= 200 && response.status < 300) {
        const resultado = state.solicitudesContrato.find((e) => e.id === id);
        resultado.status = payload;

        const updatedSolicitudes = state.solicitudesContrato.map((solicitud) =>
          solicitud.id === id ? resultado : solicitud
        );

        dispatch({ type: 'GET_SOLICITUDES_WITH_CONTRATO', payload: updatedSolicitudes });
        dispatch({ type: 'ANULAR_SOLICITUD', payload: updatedSolicitudes });

        return true;
      } else {
        throw new Error('Error al anular la solicitud. Código de estado inesperado.');
      }
    } catch (error) {
      console.error('Error en anularSolicitud:', error);
      throw error;
    }
  };

  // GET Contratos con IC

  const getContratosWithIC = async () => {
    axios.defaults.headers.common['Authorization'] = localStorage.getItem(TOKEN);
    try {
      const resultado = await axios.get(`${REACT_APP_PRESTADOR_API_URL}/consultorios/contratos`);
      // const resultado = getMock('contratos');
      dispatch({ type: 'GET_CONTRATOS_WITH_IC', payload: resultado.data });
    } catch (error) {
      throw new Error(error);
    }
  };

  // GET Consultorios con Contrato

  const getConsultoriosWithContrato = async (contrato) => {
    axios.defaults.headers.common['Authorization'] = localStorage.getItem(TOKEN);

    if (!contrato) return;

    let resultado;
    try {
      resultado = await axios.get(
        `${REACT_APP_PRESTADOR_API_URL}/consultorios/osdeWithContrato?contrato=${contrato}`
      );
    } catch (error) {
      const data = fallbackOsdeContratoPayload();
      setCuitNumber('');
      dispatch({ type: 'GET_CONSULTORIOS_WITH_CONTRATO', payload: data });
      return data;
    }

    const data = resultado.data;

    setCuitNumber(data.cuit ?? '');

    const consultorios = data?.consultorioOsde || [];

    if (consultorios.length > 0) {
      const claveOsde = consultorios[0].consultorioId;

      try {
        const infoCdResponse = await getVerifContratoCd(claveOsde);
        const infoCdData = infoCdResponse?.data || {};

        data.consultorioDigital = infoCdData.bloqueoPorConsultorioDigital
          ? {
              ...infoCdData,
              blockingReason: CONSULTORIO_CONNECTION_BLOCKING_REASON.CONSULTORIO_DIGITAL
            }
          : infoCdData;
      } catch (error) {
        console.error('Error al verificar Consultorio Digital:', error);
        data.consultorioDigital = { estaEnConsultorioDigital: false };
      }

      try {
        const turnosResponse = await getVerifTurnosFuturos(claveOsde);
        const turnosData = turnosResponse?.data || {};

        data.turnosFuturos = turnosData;
      } catch (error) {
        console.error('Error al verificar Turnos Futuros:', error);
        data.turnosFuturos = { tieneTurnos: false, cantidadTurnos: 0 };
      }
    } else {
      data.consultorioDigital = { estaEnConsultorioDigital: false };
      data.turnosFuturos = { tieneTurnos: false, cantidadTurnos: 0 };
    }

    dispatch({ type: 'GET_CONSULTORIOS_WITH_CONTRATO', payload: data });
    return data;
  };

  // GET Solicitudes con Contrato

  const getSolicitudesWithContrato = async (contrato) => {
    axios.defaults.headers.common['Authorization'] = localStorage.getItem(TOKEN);

    try {
      const resultado = await axios.get(
        `${REACT_APP_PRESTADOR_API_URL}/solicitudes/contrato?contrato=${contrato}`
      );

      // const resultado = getMock('solicitudesWithContrato');
      setIsLoading(false);
      dispatch({ type: 'GET_SOLICITUDES_WITH_CONTRATO', payload: resultado.data });
      return resultado.data;
    } catch (error) {
      throw new Error(error);
    }
  };

  // GET IC con Contrato

  const getIcWithContrato = async (contrato) => {
    axios.defaults.headers.common['Authorization'] = localStorage.getItem(TOKEN);

    try {
      const resultado = await axios.get(
        `${REACT_APP_PRESTADOR_API_URL}/getIcWithContrato?contrato=${contrato}`
      );

      // const resultado = getMock('solicitudesWithContrato');
      setIsLoading(false);
      dispatch({ type: 'GET_IC_WITH_CONTRATO', payload: resultado.data });
    } catch (error) {
      throw new Error(error);
    }
  };

  // GET consulta si contrato esta en CD

  const getVerifContratoCd = async (claveOsde) => {
    axios.defaults.headers.common['Authorization'] = localStorage.getItem(TOKEN);

    try {
      const resultado = await axios.get(
        `${REACT_APP_PRESTADOR_API_URL}/turnos/infoCd?claveOsde=${claveOsde}`
      );

      setIsLoading(false);
      return resultado;
    } catch (error) {
      throw new Error(error);
    }
  };

  const getVerifTurnosFuturos = async (claveOsde) => {
    axios.defaults.headers.common['Authorization'] = localStorage.getItem(TOKEN);

    try {
      const resultado = await axios.get(
        `${REACT_APP_PRESTADOR_API_URL}/turnos/turnosFuturos?claveOsde=${claveOsde}`
      );

      setIsLoading(false);
      return resultado;
    } catch (error) {
      throw new Error(error);
    }
  };

  const getHealthCheck = async () => {
    axios.defaults.headers.common['Authorization'] = localStorage.getItem(TOKEN);
    try {
      const resultado = await axios.get(`${REACT_APP_PRESTADOR_API_URL}/api-version`);
      return resultado.data;
    } catch (error) {
      throw new Error(error);
    }
  };

  const getPreferenciaNotificacion = async (claveOsde, cuit) => {
    axios.defaults.headers.common['Authorization'] = localStorage.getItem(TOKEN);
    try {
      const resultado = await axios.get(
        `${REACT_APP_PRESTADOR_API_URL}/consultorios/preferencias-notificacion/${cuit}/${claveOsde}`
      );
      return resultado.data;
    } catch (error) {
      throw new Error(error);
    }
  };

  const updatePreferenciaNotificacion = async (claveOsde, cuit, payload) => {
    axios.defaults.headers.common['Authorization'] = localStorage.getItem(TOKEN);
    try {
      const resultado = await axios.put(
        `${REACT_APP_PRESTADOR_API_URL}/consultorios/preferencias-notificacion/${cuit}/${claveOsde}`,
        payload
      );
      return resultado.data;
    } catch (error) {
      throw new Error(error);
    }
  };

  const getLocalHostname = async () => {
    try {
      const resultado = await axios.get('/prestador/hostname');
      return resultado.data;
    } catch (error) {
      throw new Error(error);
    }
  };

  return (
    <>
      <AgendaContext.Provider
        value={{
          initialize,
          prestadorSesion: state.prestadorSesion,
          prestadoresOsde: state.prestadoresOsde,
          solicitudesPrestador: state.solicitudesPrestador,
          prestadorExterno: state.prestadorExterno,
          proveedores: state.proveedores,
          consultorios: state.consultorios,
          solicitudDetail: state.solicitudDetail,
          consultorioDetail: state.consultorioDetail,
          errorAuthPrestador: state.errorAuthPrestador,
          contratos: state.contratos,
          consultoriosContrato: state.consultoriosContrato,
          solicitudesContrato: state.solicitudesContrato,
          motivosRechazo: state.motivosRechazo,
          icWithContrato: state.icWithContrato,
          useBlockerOK,
          isLoading,
          cuitNumber,
          datosContactoPrestadorLogeado,
          prestadorLogueado,
          proveedorSeleccionado,
          solicitudProps,
          contratoSeleccionado,
          filialSeleccionada,
          setFilialSeleccionada,
          setContratoSeleccionado,
          setUseBlockerOK,
          setProveedorSeleccionado,
          setIsLoading,
          setSolicitudProps,
          setCuitNumber,
          getPrestadorSesion,
          getExterno,
          getSolicitudes,
          getToken,
          getInfoSolicitud,
          getAllConsultorios,
          getVerifUsuarioAuth,
          getDatosContactoPrestador,
          getContratosWithIC,
          getConsultoriosWithContrato,
          getSolicitudesWithContrato,
          getMotivosRechazo,
          getIcWithContrato,
          postSolicitud,
          postSolicitudModificar,
          postInformarProveedor,
          dispatch,
          anularSolicitud,
          logout,
          postRegistrarAcceso,
          getHealthCheck,
          getLocalHostname,
          getPreferenciaNotificacion,
          updatePreferenciaNotificacion
        }}>
        {children}
      </AgendaContext.Provider>
    </>
  );
};

export default AgendaContextProvider;
